import { t } from "i18next";
import { use } from "react";
import { Col, Form, Row } from "react-bootstrap";

import { LotDetailContext } from "../../../../Contexts/LotDetailContext";
import { useDateUtils } from "../../../../Utilities/useDateUtils";

export function ProductWriteOnFields() {
    const {
        lotDetail: {
            summary: {
                productWriteOnSentUtc
            }
        }
    } = use(LotDetailContext);

    const { convertUTCToShortDateTime } = useDateUtils();

    return (
        <>
            <Form.Group as={Col} sm={6} controlId="formProductWriteOnSent">
                <Row>
                    <Form.Label column sm={4}>{`${t('LotDetails.Summary.ProductWriteOnSent')}:`}</Form.Label>
                    <Col sm={8}>
                        <div className="d-flex justify-content-start">
                            <Form.Control type="text" disabled value={productWriteOnSentUtc ? convertUTCToShortDateTime(productWriteOnSentUtc) : ""} />
                        </div>
                    </Col>
                </Row>
            </Form.Group>
            <Form.Group as={Col} sm={6} controlId="formBuildEnd">
                <Row>
                    <Form.Label column sm={4}></Form.Label>
                    <Col sm={8}>
                        <div className="d-flex justify-content-start">
                        </div>
                    </Col>
                </Row>
            </Form.Group>
        </>
    );
}